export default __webpack_public_path__ + "static/media/20.288a19dd.svg";